import LoadData from "./LoadData";
export default LoadData;
